import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
const Response = z.object({
    data: z.object({}),
});
export const url = () => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/trade-engine/staging`
    : `https://middleware.uat.farther.com/investment/trade-engine/staging`;
export const deleteAllStagedOrders = async (idempotencyKey, config) => {
    const { data } = await axios.delete(url(), {
        headers: {
            version: "20241121",
            "Content-Type": "application/json",
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ["idempotency-key"]: idempotencyKey,
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return;
    }
    const errorMessage = `[${deleteAllStagedOrders.name}.ts] received unexpected data`;
    errorLog(errorMessage, decoded.error.message);
    throw new ValidationError(errorMessage, decoded.error.issues);
};
//# sourceMappingURL=deleteAllStagedOrders.js.map